module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    ref: "svg",
    staticClass: "vector",
    class: _vm.classes,
    attrs: {
      "viewBox": _vm.setViewbox()
    },
    on: {
      "mousemove": _vm.setOffset
    }
  }, [_c('g', {
    attrs: {
      "fill": "#0f2f59",
      "stroke": "none",
      "opacity": _vm.alpha ? _vm.alpha : 0.5,
      "transform": _vm.transforms
    }
  }, [_c('path', {
    attrs: {
      "opacity": _vm.opacity.a,
      "d": _vm.pathA
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "opacity": _vm.opacity.b,
      "d": _vm.pathB
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "opacity": _vm.opacity.c,
      "d": _vm.pathC
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "opacity": _vm.opacity.d,
      "d": _vm.pathD
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "opacity": _vm.opacity.e,
      "d": _vm.pathE
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "opacity": _vm.opacity.f,
      "d": _vm.pathF
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "opacity": _vm.opacity.g,
      "d": _vm.pathG
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "opacity": _vm.opacity.h,
      "d": _vm.pathH
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "opacity": _vm.opacity.i,
      "d": _vm.pathI
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "opacity": _vm.opacity.j,
      "d": _vm.pathJ
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "opacity": _vm.opacity.k,
      "d": _vm.pathK
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "opacity": _vm.opacity.l,
      "d": _vm.pathL
    }
  })]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "vector-images"
    }
  }, [(!_vm.hideImages && !_vm.mobileImages) ? _c('g', _vm._l((_vm.images), function(image) {
    return _c('image', {
      staticClass: "vector__image",
      attrs: {
        "width": "200",
        "height": "62",
        "x": "-100",
        "y": "-31",
        "opacity": _vm.opacity.image,
        "transform": ("translate(" + (_vm.points[image.key]) + ")"),
        "xlink:href": image.url
      },
      on: {
        "click": function($event) {
          _vm.routeImage(image.path)
        }
      }
    })
  })) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-bbfb5fb4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/graphics/BackgroundVector.vue
// module id = 652
// module chunks = 1